import { render, staticRenderFns } from "./Tack.vue?vue&type=template&id=1fb671ec&scoped=true"
import script from "./Tack.vue?vue&type=script&lang=js"
export * from "./Tack.vue?vue&type=script&lang=js"
import style0 from "./Tack.vue?vue&type=style&index=0&id=1fb671ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb671ec",
  null
  
)

export default component.exports